import type { ErrorKind } from './LobbySession.js';
import type { ClosedDoorReason } from '../shared/components/ClosedDoorCard.js';

/**
 * Maps a boot/join failure `ErrorKind` to the `ClosedDoorCard` reason that
 * names the surface shown to the player. This literal mapping is the data
 * boundary (Epic 14-hardening); the atmospheric copy lives in i18n
 * (`errors.closedDoor.*`) and the visual in `ClosedDoorCard`. Pure +
 * unit-tested. (Replaces the prior flat-i18n-key mapping `bootFailedKey`.)
 *
 * `schema_mismatch` also surfaces via `connection === 'schemaMismatch'`, which
 * App maps straight to `'schemaMismatch'`; it is handled here too so a failed
 * boot carrying that kind resolves identically.
 */
export function closedDoorReason(kind: ErrorKind | undefined): ClosedDoorReason {
  switch (kind) {
    case 'room_full':
      return 'roomFull';
    case 'game_in_progress':
      return 'gameInProgress';
    case 'schema_mismatch':
      return 'schemaMismatch';
    case 'identity_denied':
      return 'accessDeclined';
    default:
      // connect_error, join_error, disconnected, identity_error, undefined
      return 'couldntConnect';
  }
}
